// Shared project presentation helpers — the phase pill + the poster art
// class, used by BOTH the Projects poster grid and the ProjectDetail hero so
// the two never drift. Mirrors the demo's `.ph`/`ART` treatment (a phase
// pill per lifecycle state, a medium-tinted poster gradient).

export interface PhasePill {
  label: string;
  /** The modifier suffix on `.ph--<cls>` (see Projects.css). */
  cls: 'aud' | 'book' | 'rel';
}

// actor_project lifecycle states -> the demo's pill copy + hue.
export const PHASE_PILL: Record<string, PhasePill> = {
  auditioned: { label: 'Auditioned', cls: 'aud' },
  booked: { label: 'Booked', cls: 'book' },
  released: { label: 'Released', cls: 'rel' },
};

// The actor_project `medium` picklist (film/tv/theatre/new_media/commercial/
// other) -> a poster-art modifier class. Anything unmapped (or absent) falls
// back to the neutral gradient, never a broken class.
const ART_MEDIUM: Record<string, string> = {
  film: 'poster__art--film',
  tv: 'poster__art--tv',
  theatre: 'poster__art--theatre',
  new_media: 'poster__art--voice',
  commercial: 'poster__art--commercial',
  other: 'poster__art--other',
};

export function phaseArtClass(medium: string | null): string {
  return (medium && ART_MEDIUM[medium]) ?? 'poster__art--other';
}
